import type {RequestMediaPermissions} from './types';

import {logger} from '../logger';
import {DevicePermission} from './DevicePermission';

export const requestMediaPermissions: RequestMediaPermissions = async (
  permissions = [DevicePermission.MICROPHONE, DevicePermission.CAMERA],
) => {
  try {
    if (!navigator.mediaDevices) {
      logger.error(new Error('navigator.mediaDevices is not available'));
    }

    await navigator.mediaDevices.getUserMedia({
      audio: permissions.includes(DevicePermission.MICROPHONE),
      video: permissions.includes(DevicePermission.CAMERA),
    });
  } catch (error) {
    logger.error(error);
    // if not granted, do nothing
  }
};
